exports.components = {
  "component---src-pages-civic-data-api-jsx": () => import("./../../../src/pages/civic-data-api.jsx" /* webpackChunkName: "component---src-pages-civic-data-api-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-legal-page-jsx": () => import("./../../../src/templates/legal-page.jsx" /* webpackChunkName: "component---src-templates-legal-page-jsx" */)
}

